import React from 'react';
import PropTypes from 'prop-types';

import { Download } from '../../assets/icons';

import './TradeItem.scss';
import { toastNotify } from '../../utils/toastNotify';

const TradeItem = ({ date, trade, amount, actionURL }) => {
  const onDownloadFile = async () => {
    if (!actionURL) {
      toastNotify('error', 'Sorry, Could not download the file!');
      return;
    }
    try {
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', actionURL);
      a.setAttribute('target', '_blank');
      a.setAttribute('download', actionURL);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      toastNotify('error', 'Something went wrong.');
    }
  };

  return (
    <div className='tradeitem'>
      <p className='tradeitem__date'>{date}</p>
      <p className='tradeitem__trade'>{trade}</p>
      <p className='tradeitem__amount'>{amount}</p>
      <div className='tradeitem__download' onClick={onDownloadFile}>
        <Download verticalAlign='-4px' color='#4F3D38' />
      </div>
    </div>
  );
};

TradeItem.propTypes = {
  date: PropTypes.string,
  trade: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionURL: PropTypes.string,
};

TradeItem.defaultProps = {
  date: 'NA',
  trade: 'NA',
  amount: '$0.00',
  actionURL: '',
};

export default TradeItem;
